import {
  DireccionDTO,
  ClienteDTO,
  SedeDTO,
} from 'src/app/clientes/utilidades/clientes.models';
import { FilaTabla } from 'src/app/compartido/tabla/utilidades/tabla.models';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import {
  EstadoOrden,
  FormulaDTO,
  ItemOrdenDTO,
  OrdenDTO,
  TipoPreparacion,
} from './ordenes.models';
import { Domicilio } from 'src/app/domicilios/utilidades/domicilio.class';
import { EstadoDomicilio } from 'src/app/domicilios/utilidades/domicilios.models';

/* Orden */
export class Orden {
  constructor(
    public id: number,
    public fechaCreacion: string,
    public autorCreacion: string | null,
    public titulo: string,
    public referencia: string | null,
    public referenciaDisplay: string | null,
    public tipo: string,
    public tipoDisplay: string,
    public prioridad: string,
    public prioridadDisplay: string,
    public estado: EstadoOrden,
    public estadoDisplay: string,
    public estadoReal: EstadoOrden | EstadoDomicilio,
    public estadoRealDisplay: string,
    public origen: SedeDTO | null,
    public centroCosto: string | null,
    public servicio: string | null,
    public recaudo: number,
    public direccion: DireccionDTO,
    public cliente: ClienteDTO,
    public items: ItemOrdenDTO[],
    public formulas: FormulaDTO[],
    public notas: string | null,
    public antecesora: number | null,
    public sucesora: number | null,
    public domicilio: Domicilio | null,
    public etiquetaGenerada: boolean,
    public fechaCancelacion: string | null,
    public motivoCancelacion: string | null,
    public autorCancelacion: string | null,
    public observacionCancelacion: string | null,
    public fechaAplazamiento: string | null,
    public motivoAplazamiento: string | null,
    public observacionAplazamiento: string | null,
    public autorAplazamiento: string | null,
    public aplazadaHasta: string | null,
    public tipoPreparacion: TipoPreparacion | null,
    public tipoPreparacionDisplay: string | null,
    public fechaPreparacion: string | null,
    public motivoRechazo: string | null,
    public autorPreparacion: string | null,
    public observacionPreparacion: string | null,
    public sinDomicilio: boolean,
    public motivoSinDomicilio: string | null,
    public fechaRecogida: string | null,
    public autorRecogida: string | null,
    public planilla: number | null,
  ) {}

  /**
   * Devuelve los datos de la orden con el formato para tabla
   * @returns {FilaTabla} - Los datos formateados para tabla
   * @author Juan Corral
   */
  public datosTabla(): FilaTabla {
    return {
      id: this.id,
      fecha_creacion: this.fechaCreacion,
      titulo: this.titulo,
      referencia: this.referencia,
      tipo: this.tipo,
      tipo_display: this.tipoDisplay,
      prioridad: this.prioridad,
      prioridad_display: this.prioridadDisplay,
      estado: this.estado,
      estado_display: this.estadoDisplay,
      estado_real: this.estadoReal,
      estado_real_display: this.estadoRealDisplay,
      origen: this.origen?.nombre,
      fecha_preparacion: this.fechaPreparacion,
      direccion: this.direccion.direccion_formateada,
      nombre: this.cliente.nombre,
      identificacion: this.cliente.identificacion,
      cliente: this.cliente.nombre + ' - ' + this.cliente.identificacion,
      items: this.items ? this.items.length : 0,
      formulas: this.formulas ? this.formulas.length : 0,
      notas: this.notas,
      domicilio: this.domicilio?.id,
      etiqueta_generada: this.etiquetaGenerada,
      aplazada: this.aplazadaHasta ? true : false,
    };
  }

  /**
   * Crea un objeto Orden a partir de los datos del API.
   * @param {OrdenDTO} orden - La orden como llega del API.
   * @returns {Orden} - El objeto Orden creado.
   * @author Juan Corral
   */
  public static fromDTO(orden: OrdenDTO): Orden {
    return new Orden(
      orden.id,
      formatearFecha(orden.fecha_creacion),
      orden.autor_creacion,
      orden.titulo,
      orden.referencia,
      orden.referencia_display,
      orden.tipo,
      orden.tipo_display,
      orden.prioridad,
      orden.prioridad_display,
      orden.estado,
      orden.estado_display,
      orden.estado_real,
      orden.estado_real_display,
      orden.origen,
      orden.centro_costo,
      orden.servicio,
      orden.recaudo,
      orden.direccion,
      orden.cliente,
      orden.items,
      orden.formulas,
      orden.notas,
      orden.antecesora,
      orden.sucesora,
      orden.domicilio ? Domicilio.fromDTO(orden.domicilio) : null,
      orden.etiqueta_generada,
      orden.fecha_cancelacion ? formatearFecha(orden.fecha_cancelacion) : null,
      orden.motivo_cancelacion,
      orden.autor_cancelacion,
      orden.observacion_cancelacion,
      orden.fecha_aplazamiento
        ? formatearFecha(orden.fecha_aplazamiento)
        : null,
      orden.motivo_aplazamiento,
      orden.observacion_aplazamiento,
      orden.autor_aplazamiento,
      orden.aplazada_hasta ? formatearFecha(orden.aplazada_hasta) : null,
      orden.tipo_preparacion,
      orden.tipo_preparacion_display,
      orden.fecha_preparacion ? formatearFecha(orden.fecha_preparacion) : null,
      orden.motivo_rechazo,
      orden.autor_preparacion,
      orden.observacion_preparacion,
      orden.sin_domicilio,
      orden.motivo_sin_domicilio,
      orden.fecha_recogida ? formatearFecha(orden.fecha_recogida) : null,
      orden.autor_recogida,
      orden.planilla,
    );
  }
}
